module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Tomb-Raider.bf5a0c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Tomb-Raider.jpg
// module id = GAtr
// module chunks = 0